import { render, staticRenderFns } from "./ZooomImageIcon.vue?vue&type=template&id=2212977e"
import script from "./ZooomImageIcon.vue?vue&type=script&lang=js"
export * from "./ZooomImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports